/** Resolve a completed scanner URL without losing count-sheet provenance. */
export function scanDestination(value: string): string | null {
  const session = value.match(/\/os\/count\/([0-9a-f]{32})(?=[/?#\s]|$)/i);
  if (session) return `/os/count/${session[1].toLowerCase()}`;
  const item = value.match(/\/os\/scan\/([^/\s?#]+)\/(working|storeroom)(?=[?#\s]|$)([^\s]*)/i);
  if (!item) return null;
  let code: string;
  try { code = decodeURIComponent(item[1]); } catch { return null; }
  const query = item[3].split('#')[0];
  const source = new URLSearchParams(query).get('src');
  return `/os/scan/${encodeURIComponent(code)}/${item[2].toLowerCase()}${source === 'sheet' ? '?src=sheet' : ''}`;
}
